import { Component, Input } from '@angular/core';
import { ICardInfoData } from '../../interfaces/card-info.interface';

@Component({
  selector: 'app-numbered-card',
  imports: [],
  templateUrl: './numbered-card.html',
  styleUrl: './numbered-card.scss'
})
export class NumberedCard {

  @Input() info!: ICardInfoData;
}
